<template>
  <div>
    <div class="mainContainer" style="background-color: #fff;padding: 0px;">

      <div class="disFlex itypeBq">
        <!-- <span class="xx-label">类别</span> -->
        <span :class="kcSmallItype==''?'active':''" style="padding: 3px 15px;"
          @click="changeParams('kcSmallItype','')">全部</span>
        <span v-for="k in smallItypes" @click="changeParams('kcSmallItype',k.uniqueCode)"
          :class="kcSmallItype==k.uniqueCode?'active':''">{{k.text}}</span>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="mainContainer disFlex between"
      style="background-color: #fff;margin: 20px auto;height: 60px;align-items: center;">

      <div style="padding-right: 22px;">
        <el-input placeholder="请输入名称进行搜索" suffix-icon="el-icon-search" v-model="params.keyword">
        </el-input>
      </div>
    </div>
    <div v-loading="loading">
      <div class="mainContainer">
        <div class="disFlex" style="flex-wrap: wrap;" v-if="tableData.rows.length>0">
          <div v-for="(item,k) in tableData.rows" class="zyjn-every"
            :style="k>0&&k%4==3?'margin-right:0;height:240px;':'height:240px;'" @click="baoming(item)">
            <div><img :src="wjSrc+item.imgPath" /></div>
            <div class="kcxc-every-tit">{{item.title}}【{{item.itypeName}}】</div>
          </div>
        </div>
        <div v-else style="height: 327px;background-color: #fff;text-align: center;">
          <img style="margin: 113px 0 20px;" src="@/assets/images/nodata.png" />
          <div style="font-size: 18px;color: #999999;">暂无数据</div>
        </div>
      </div>

      <div class="mainContainer" style="text-align: center;">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="params.page" :page-sizes="[12, 48, 96, 192]" :page-size="100"
          layout="total,prev, pager, next, jumper" :total="tableData.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    name: 'Home',
    props: ['currentUser', 'isDenglu', 'wjSrc'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('手机号不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('手机号码有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        zyjnFlag: 0,
        zyzcFlag: 0,
        activeName: '001',
        lrkx: {
          margin: '0 15px 10px'
        },
        currentPage1: 5,
        currentPage2: 5,
        currentPage3: 5,
        currentPage4: 4,
        name: '',
        kcBigItype: '',
        kcSmallItype: '',
        priceItype: 'all',
        params: {
          page: 1,
          rows: 12,
          itype: '',
          keyword: '',
          nocid: '1'
        },
        tableData: {
          rows: [],
          total: 0
        },
        loading: true,
        options: [],
        smallItypes: []
      }
    },
    methods: {
      handleSizeChange(val) {
        this.$set(this.params, 'page', val);
      },
      handleCurrentChange(val) {
        this.$set(this.params, 'rows', val);
      },
      changeParams: function(name, value, k) {
        this[name] = value;
        if (name == 'kcBigItype') {
          this.kcSmallItype = '';
          this.smallItypes = this.options[k].children;
        }
        if (name == 'kcSmallItype' || name == 'kcBigItype') {
          this.$set(this.params, 'itype', value)
        } else {
          this.$set(this.params, name, value)
        }
      },
      getKclist: function() {
        var params = this.params;
        // delete params.zhpx;
        // delete params.xlpx;
        // delete params.jgpx;
        this.loading = true;
        this.$axios.get('/kt/productCourse/getlistPage.htm?' + this.$qs.stringify(this.params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.tableData = data;
          this.loading = false;
        })
      },
      baoming: function(item) {
        if (item.fileType == '1') {
          this.$router.push('/Xjdetail?id=' + item.id);
        } else {
          window.open(this.wjSrc + item.filePath)
        }
      },
      getPxitype: function() {
        this.$axios.get('/system/datadict/tree.htm?supCode=ZXKT_KPXC&state=1', {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.smallItypes = data;
        })
      }
    },
    created: function() {
      this.getKclist()
      this.getPxitype();
    },
    watch: {
      params: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getKclist()
        },
        deep: true //true 深度监听
      }
    }
  }
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/components/common/XjzxInfo.vue